import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { InView } from 'react-intersection-observer';
import parse from 'html-react-parser';
import PropTypes from 'prop-types';
import SubHead from '../SubHead/SubHead';
import MiniHed from '../SubHead/MiniHed';
import BodyText from '../BodyText/BodyText';
import Button from '../../../common/Button';
import { isValid, isText, decodeTags, sendLog } from '../../../../utils';
import $ from 'jquery';
import "./embed-module.scss";

class EmbedModule extends Component {
  constructor(props) {
    super(props);
    this.loadTwitterScript = this.loadTwitterScript.bind(this);
    this.loadInstaScript = this.loadInstaScript.bind(this);
    this.loadTikTokScript = this.loadTikTokScript.bind(this);
    this.loadGenericScript = this.loadGenericScript.bind(this);
    this.stripInstaScript = this.stripInstaScript.bind(this);
    this.processEmbed = this.processEmbed.bind(this);
    this.stripOpenHausScript = this.stripOpenHausScript.bind(this);
    this.getCerosPage = this.getCerosPage.bind(this);
    this.setCerosSrc = this.setCerosSrc.bind(this);
    this.cerosSrc = null;
  }

  setCerosSrc(encodedData) {
    if (isValid(encodedData)) {
      const parsedEmbed = parse(encodedData);
      const parsedArray = Array.isArray(parsedEmbed) ? parsedEmbed : [parsedEmbed];
      const frameContainer = isValid(parsedArray) ? parsedArray.filter(tag => tag.type === 'div') : null;
      const containerChildren = (isValid(frameContainer) && isValid(frameContainer[0].props) && isValid(frameContainer[0].props.children)) ? frameContainer[0].props.children : null;
      let embedFrame;
      if (typeof(containerChildren) === 'array') {
        embedFrame = containerChildren.filter(tag => tag.type == 'iframe')[0];
      } else {
        embedFrame = containerChildren.type === 'iframe' ? containerChildren : null;
      }
      const cerosSrc = (isValid(embedFrame) && isValid(embedFrame.props) && isValid(embedFrame.props.src)) ? embedFrame.props.src : null;
      this.cerosSrc = cerosSrc;
    }
  }
  getCerosPage(embed) {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const urlPage =  (this.props.isMobile) ? urlParams.get('anchor') : urlParams.get('page') || '1'; // Default to page 1 if no parameter
      return urlPage;
    } catch(e) {
      return null;
    }
  }
  loadGenericScript(encodedData, isCerosExperience) {
    if (isValid(encodedData) && isCerosExperience) {
      const cerosFrame = document.querySelector('iframe.ceros-experience');
      const cerosPage = this.getCerosPage();
      const rawSrc = this.cerosSrc.split("?");
      const cerosUrl = isValid(cerosPage) ? (this.props.isMobile) ? `${this.cerosSrc}#${cerosPage}` : `${rawSrc[0]}/p/${cerosPage}?${rawSrc[1]}` : this.cerosSrc;
      cerosFrame.src = cerosUrl;
    }
    if (isValid(encodedData) && !isCerosExperience) {
      const parsedEmbed = parse(encodedData);
      const embedScript = parsedEmbed.filter(tag => tag.type == 'script');
      if(isValid(embedScript)) {
        const scriptSrc = (isValid(embedScript[0].props) && isValid(embedScript[0].props.src)) ? embedScript[0].props.src : null;
        if(scriptSrc) {
          const script = document.createElement('script');
          script.src = scriptSrc;
          script.async = true;
          document.body.appendChild(script);
        }
      }
    }
  }

  loadTwitterScript() {
    const script = document.createElement('script');
    script.src = 'https://platform.twitter.com/widgets.js';
    script.async = true;
    document.body.appendChild(script);
  }

  loadTikTokScript() {
      const script = document.createElement('script');
      script.src = 'https://www.tiktok.com/embed.js';
      script.async = true;
      document.body.appendChild(script);
  }

  loadInstaScript() {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
      return;
    }
    if (document.querySelector('script[data-purewow-instagram]')) return;
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.instagram.com/embed.js';
    script.setAttribute('data-purewow-instagram', 'true');
    script.onload = () => window.instgrm && window.instgrm.Embeds.process();
    document.body.appendChild(script);
  }

  stripInstaScript(encodedData) {
    try {
      return encodedData.replace('<script async defer src="//www.instagram.com/embed.js"></script>', '');
    } catch (e) {
      console.log(e);
      return null;
    }
    
  }

  stripOpenHausScript(encodedData) {
    try {
      return encodedData.split('jQuery')[0];
    } catch (e) {
      console.log(e);
      return null;
    }
  }

  processEmbed(embed, isInsta, isOpenHaus, isCerosExperience) {
    const encodedData = decodeTags(embed);
    if (isCerosExperience) {
      this.setCerosSrc(encodedData);
    }
    return isInsta ? this.stripInstaScript(encodedData) : isOpenHaus ? this.stripOpenHausScript(encodedData) : encodedData; 
  }

  componentDidMount() {
    // Code to handle OpenHaus 
    if (isValid(this.props.data.embed) && (this.props.data.embed.includes('openhaus') && !this.props.data.embed.includes('iframe'))) {
      const embedCode = decodeTags(this.props.data.embed);
      const openHausId = "#" + embedCode.split('id="').pop().split('"></div>')[0]; 
      const openHausUrl = embedCode.split('url = "').pop().split('";jQuery')[0]; 
      $.get(openHausUrl, function(data, status){
        $(openHausId).replaceWith(data);
      });
    }
  }

  render() {
    const { data, articleLayout, isAffiliate, isMobile, isClient } = this.props;
    if (!isValid(data)) { return null; }
    let { className } = this.props;
    const { embed=null, hed=null, hedBody=null, subhed=null, bodyText=null, hedPlacement=null } = data;
    const isInsta = (isValid(embed)) && embed.includes('instagram.com');
    const isPin = (isValid(embed)) && embed.includes('pinterest');
    const isTiktok = (isValid(embed)) && embed.includes('tiktok.com');
    const isTwitter = (isValid(embed)) && embed.includes('twitter');
    const isYoutube = (isValid(embed)) && embed.includes('www.youtube.com');
    const isOpenHaus = (isValid(embed)) && (embed.includes('openhaus') && !embed.includes('iframe'));
    const isCerosExperience = (isValid(embed)) && embed.includes('ceros');
    className = isPin ? className + ' pin' : className;
    className = isCerosExperience ? className = 'ceros-experience' : className;
    className = isYoutube ? className + ' youtube' : className;
    const encodedData = (isValid(embed)) ? this.processEmbed(embed, isInsta, isOpenHaus, isCerosExperience) : '';
    const renderedBodyText = bodyText ? <BodyText className="body-text" articleLayout={articleLayout} data={bodyText} isAffiliate={isAffiliate}/> : null;
    const { buttonText, buttonUrl } = data;
    const button = (isText(buttonText) && isText(buttonUrl)) ? { text: buttonText, url: buttonUrl } : null;
    const renderedButton = (button !== null) ? <Button button={button} /> : null;
    const rootMargin = `0% 0% ${isMobile && (isInsta || isTiktok || isTwitter) ? '75%' : isInsta || isMobile || isTiktok || isTwitter ? '60%' : '25%'} 0%`;

    return (
        <Fragment>
          { isOpenHaus &&
            <Helmet encodeSpecialCharacters={false}>
              <script async defer src="https://ajax.googleapis.com/ajax/libs/jquery/2.1.3/jquery.min.js"></script>
            </Helmet>
          }
          { hedPlacement !== "below" &&
            <Fragment>
              {hed && <SubHead className="sub-head embed-head" articleLayout={articleLayout} data={hed} />}
              {hedBody && <BodyText className="header-body" articleLayout={articleLayout} data={hedBody} />}
            </Fragment>
          }
          { isInsta &&
            <div className="embed-wrapper insta">
              <InView triggerOnce={isClient} rootMargin={rootMargin} onChange={() => this.loadInstaScript()}>
                {({ inView, ref }) => (
                  <div ref={ref}>
                    {(inView || isTiktok) &&
                      <div className={className} dangerouslySetInnerHTML={{ __html: encodedData }} />
                    }
                  </div>
                )}
              </InView>
            </div>
          }
          { isTiktok &&
            <div className="embed-wrapper tiktok">
              <InView triggerOnce={isClient} rootMargin={rootMargin} onChange={() => this.loadTikTokScript()}>
                {({ inView, ref }) => (
                  <div ref={ref}>
                    {(inView) &&
                      <div className={className} dangerouslySetInnerHTML={{ __html: encodedData }} />
                    }
                  </div>
                )}
              </InView>
            </div>
          }
          { isTwitter &&
            <div className="embed-wrapper twitter">
              <InView triggerOnce={isClient} rootMargin={rootMargin} onChange={() => this.loadTwitterScript()}>
                {({ inView, ref }) => (
                  <div ref={ref}>
                    {(inView) &&
                      <div className={className} dangerouslySetInnerHTML={{ __html: encodedData }} />
                    }
                  </div>
                )}
              </InView>
            </div>
          }
          { (!isInsta && !isTiktok && !isTwitter) &&
            <InView triggerOnce={isClient} rootMargin={rootMargin} onChange={() => this.loadGenericScript(encodedData, isCerosExperience)}>
              {({ inView, ref }) => (
                <div ref={ref}>
                  {(inView || isCerosExperience) &&
                      <div className={className} dangerouslySetInnerHTML={{ __html: encodedData }} />
                  }
                </div>
              )}
            </InView>
          }
          { hedPlacement === "below" &&
            <Fragment>
              {hed && <SubHead className="sub-head embed-head" articleLayout={articleLayout} data={hed} />}
              {hedBody && <BodyText className="header-body" articleLayout={articleLayout} data={hedBody} />}
            </Fragment>
          }
          {subhed && <MiniHed className="sub-head" articleLayout={articleLayout} data={subhed} />}
          {renderedBodyText}
          {renderedButton}
        </Fragment>
    );    
  }
}

EmbedModule.propTypes = {
  className: PropTypes.string,
};

export default EmbedModule;
